var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('SwiperView',{attrs:{"slides":_vm.slides}}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":require('@/assets/master.jpg'),"alt":""}})]),_vm._m(0)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('h1',[_vm._v("Strategic, purpose-driven business service crafted for your success.")])])
}]

export { render, staticRenderFns }